export default __webpack_public_path__ + "static/media/menuCopiarCard.0b4e2514.svg";